// NATIVE 

// INSTALLED 
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { Alert, AlertTitle,  Grid, Paper, Typography } from '@mui/material';

// CUSTOM 





/**
 * DetalleEducacion component displays the educational details of an employee.
 * 
 * This component uses the `useSelector` hook to access the employee data from the Redux store.
 * It displays the employee's scholarship, institution, and degree information in a grid layout.
 * 
 * @component
 * @example
 * return (
 *   <DetalleEducacion />
 * )
 * 
 * @returns {JSX.Element} The rendered component displaying the educational details.
 */
export const DetalleEducacion = () => {


    //  USE SELECTOR 
    const { employee }:any  = useSelector( (state:any) => state.employee );


    // CONST STYLES 
    const Item = styled(Paper)(({ theme }:any) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));


  return (
    <>

        <Alert severity="info">
          <AlertTitle>Info</AlertTitle>
            Aquí podrás encontrar informacion relacionada con estudios mas altos culminados.
        </Alert>
    
        <Grid container spacing={1} sx={{ marginTop: 3 }}>
          
            <Grid item xs={4}>
                <Item>
                   <Typography  sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> Escolaridad </Typography>

                   <Typography  sx={{ textAlign: 'center', color: 'black', marginBottom: 2, fontSize: '0.9rem', marginTop: 2, textTransform: 'capitalize' }}> { employee.scholarship } </Typography>
                </Item>
            </Grid>
            <Grid item xs={4}>
                <Item>
                   <Typography  sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> Institución </Typography>
                   <Typography  sx={{ textAlign: 'center', color: 'black', marginBottom: 2, fontSize: '0.9rem', marginTop: 2, textTransform: 'capitalize' }}> { employee.institution } </Typography>
                </Item>
            </Grid>
            <Grid item xs={4}>
                <Item>
                  <Typography  sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1rem', marginTop: 1, textTransform: 'capitalize', fontSynthesisWeight: 400 }}> Titulo </Typography>
                  <Typography  sx={{ textAlign: 'center', color: 'black', marginBottom: 2, fontSize: '0.9rem', marginTop: 2, textTransform: 'capitalize' }}> { employee.degree } </Typography>
                </Item>
            </Grid>
        </Grid>

    </>
  )
}
